import React from 'react'
import { Space, Input, Button } from 'antd'
import * as Icons from '@ant-design/icons'
import { useQueryParam, StringParam } from 'use-query-params'
import { Link } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

import { UsersList } from './UsersList'

export function Users() {
  const [searchName, setSearchName] = useQueryParam('name', StringParam)
  const [searchEmail, setSearchEmail] = useQueryParam('email', StringParam)
  const [searchMemberships, setSearchMemberships] = useQueryParam(
    'memberships',
    StringParam
  )

  return (
    <Layout
      header={
        <>
          <Breadcrumb items={[{ title: 'Users' }]} />

          <Space>
            <Input
              value={searchName}
              onChange={e => setSearchName(e.target.value)}
              style={{ maxWidth: '12rem' }}
              addonBefore="Name"
            />

            <Input
              value={searchEmail}
              onChange={e => setSearchEmail(e.target.value)}
              style={{ maxWidth: '12rem' }}
              addonBefore="Email"
            />

            <Input
              value={searchMemberships}
              onChange={e => setSearchMemberships(e.target.value)}
              style={{ maxWidth: '15rem' }}
              addonBefore="Memberships"
            />

            <Link to={ROUTES.USERS.NEW}>
              <Button icon={<Icons.UserAddOutlined />} type="primary">
                Register
              </Button>
            </Link>
          </Space>
        </>
      }
    >
      <UsersList
        searchName={searchName}
        searchEmail={searchEmail}
        searchMemberships={searchMemberships}
      />
    </Layout>
  )
}
